<template>
  <div class="page-wrapper" :class="{ 'is-usa' : ($route.query && $route.query.market === 'usa' || $route.query && $route.query.market === 'to') }">

    <div v-if="$route.query && $route.query.market === 'usa' && marketPrice" class="usa">
      <img src="@/assets/img/usa-flag.png" alt="USA" />
      <p class="small-title">$1 USD = ${{ parseFloat(marketPrice, 2).toFixed(2) }} CAD = <span>big savings*</span>  |  <a href="https://www.tremblant.ca/mountain-village/health-measures?sc_lang=en" target="_blank"><span>End of COVID-19</span> border and travel restrictions</a></p>
    </div>
    <a href="#vols" v-scroll-to:-80 v-if="$route.query && $route.query.market === 'to' && marketPrice" class="usa to">
      <img src="@/assets/img/fly-ski-free.svg" class="fly" alt="Fly and ski free">
      <p class="small-title">Fly & Ski Free | Direct flights from Toronto</p>
    </a>

    <header class="main-header" :class="{ 'covid-actif' : ($route.query && $route.query.market === 'usa' || $route.query && $route.query.market === 'to') }">
      <div class="left">
        <img src="@/assets/img/logo.svg" class="logo" alt="Logo Tremblant" />
        <img v-if="$route.meta.lang === 'fr'" src="@/assets/img/tagline-fr.svg" class="tagline" alt="Tagline Tremblant" />
        <img v-else-if="$route.meta.lang === 'en'" src="@/assets/img/tagline-en.svg" class="tagline" alt="Tagline Tremblant" />
      </div>
      <div class="right">
        <div class="links">
          <a href="tel:18887381777">1-888-738-1777</a>
          <p>|</p>
          <router-link v-if="pageData && $route && $route.meta.lang === 'fr'" :to="{ name: 'pageEn', params: { pageData } }" class="lang">EN</router-link>
          <router-link v-else-if="pageData && $route && $route.meta.lang === 'en'" :to="{ name: 'page', params: { pageData } }" class="lang"
            >FR</router-link
          >
        </div>
        <a href="#" class="cta red" @click.prevent="showlodgingform">{{ $t('site.reservez-long') }}</a>
      </div>
      <a href="tel:18887381777" class="phone-mobile"><img src="@/assets/img/phone4.svg" alt="Call Tremblant" /></a>
      <div class="mobile-cta">
        <a href="#" class="cta red" @click.prevent="showlodgingform">{{ $t('site.reservez-long') }}</a>
      </div>
    </header>

    <section class="hero hiver_2023_in_season_dink">
      <div class="img-mobile"></div>
      <div class="deal-wrap" data-inview="slideLeft" data-delay="100">
        <div class="top">
          <img src="@/assets/img/curve-green.svg" alt="Curve" />
          <div class="data"><h2 class="big-title" v-html="$t('site.slogan')"></h2></div>
        </div>
        <div class="bottom flex-end">
          <div class="deal">
            <h2 class="small-title" v-html="$t('site_hiver_2023.al_lodging_hero')"></h2>
            <a href="#" class="cta blanc-bleu" @click.prevent="showlodgingform">{{ $t('site.reservez-short') }}</a>
            <a href="#" class="regular-text" @click.prevent="function() { showdealpanel(); table1(); }">{{ $t('site.show-details') }}</a>
          </div>
          <div class="deal">
            <h2 class="small-title" v-html="$t('site_hiver_2023.al_entrepot_hero_small')"></h2>
            <a :href="$t('site_hiver_2023.al_entrepot_link')" target="_blank" class="cta blanc-bleu">{{ $t('site.achetez-short') }}</a>
            <a href="#" class="regular-text" @click.prevent="function() { showdealpanel(); table2(); }">{{ $t('site.show-details') }}</a>
          </div>
          <!-- <p class="cut-off">{{ $t('site_hiver_2023.al_lodging_cut') }}</p> -->
        </div>
      </div>
    </section>

    <section class="quoi_faire_wrap hiver" id="quoi-faire">
      <img src="@/assets/img/curve-prune-big.svg" class="curve" alt="Courbe" />
      <h2 class="medium-title" data-inview="fadeInUp" data-delay="200">{{ $t('site_ete_2022.experience_title') }}</h2>

      <!-- CARROUSEL EXPERIENCES -->
      <div class="quoi_faire_bloc_sroll">
        <div v-for="(item, i) in $t('dink_hiver_2023_experiences')" :key="i" class="quoi_faire_bloc" data-inview="fadeInUp" :data-delay="4 + 1 + '00'">
          <div class="img">
            <div class="overlay"></div>
            <img :src="item.img" alt="Hébergement Tremblant" />
          </div>
          <div class="data">
            <p id="counter4" class="number" :data-count-up="item.number">{{ item.number }}</p>
            <p class="small-title" v-html="item.titre"></p>
            <a
              href="#"
              class="cta blanc-prune"
              v-html="item.cta"
              @click.prevent="
                toggleDynamicSidePanel(
                  true,
                  $t('dink_hiver_2023_experiences').filter((i) => calendarActiveFilter === 'Tous' || calendarActiveFilter === 'All' || i.filter === calendarActiveFilter),
                  i
                )
              "
              ></a
            >
          </div>
        </div>
      </div>
    </section>

    <section class="activities_wrap hiver">
      <img src="@/assets/img/curve-bleu.svg" alt="curve" class="curve" />
      <div class="intro" data-inview="fadeInUp" data-delay="200">
        <h2 class="medium-title">{{ $t('site_hiver_2023.sejour_title') }}</h2>
        <p class="regular-text">
          {{ $t('site_hiver_2023.sejour_desc') }}
        </p>
        <a :href="$t('site_hiver_2023.ski_magazine_link')" target="_blank" class="regular-text center_link" data-inview="fadeInUp" data-delay="250">{{ $t('site_hiver_2023.ski_magazine') }}</a>
      </div>

      <!-- CARROUSEL ACTIVITY -->
      <div class="activities_list">
        <div v-for="(item, i) in $t('dink_hiver_2023_activity')" :key="i" class="activity" data-inview="fadeInUp" :data-delay="3 + 1 + '00'">
          <a v-if="item.video" :href="item.video" class="glightbox img">
            <img src="@/assets/img/play.svg" alt="Play" class="play" />
            <div class="overlay"></div>
            <img :src="item.img" class="activity-img" alt="Montagne Tremblant" />
          </a>
          <div v-else-if="!item.video" class="img no_click">
            <div class="overlay"></div>
            <img :src="item.img" class="activity-img" alt="Montagne Tremblant" />
          </div>
          <div class="data">
            <div v-html="item.titre"></div>
            <a
              href="#"
              class="cta blanc-bleu"
              v-html="item.cta"
              @click.prevent="
                toggleDynamicSidePanel(
                  true,
                  $t('dink_hiver_2023_activity').filter((i) => calendarActiveFilter === 'Tous' || calendarActiveFilter === 'All' || i.filter === calendarActiveFilter),
                  i
                )
              "
              ></a
            >
          </div>
        </div>
      </div>

      <!-- BRINDO -->
      <div class="brindo_wrap" data-inview="fadeInUp" data-delay="200">
        <a href="https://www.youtube.com/watch?v=hy0JHmPT440&list=TLGG1Oz2Huq2KykzMDAxMjAyMw&t=2s" class="img glightbox">
          <img src="@/assets/img/play-blue-2.svg" alt="Play" class="play" />
          <img src="@/assets/img/brindo.jpg" alt="Brind'O Tremblant" class="background" />
        </a>
        <div class="data">
          <div>
            <h2 class="big-title">Brind’o</h2>
            <h3 class="small-title" v-html="$t('site_hiver_2023.brindo_deal')"></h3>
            <a href="#" @click.prevent="showbrindopanel" class="cta bleu-vert">{{ $t('site_ete_2022.more') }}</a>
          </div>
        </div>
      </div>

    </section>

    <!--Vols-->
    <section class="vols-wrap" id="vols" v-if="$route.query && $route.query.market === 'to' && marketPrice">
      <img src="@/assets/img/curve-prune.svg" class="curve" alt="Courbe" />
      <div class="img">
        <img src="@/assets/img/vols-3.jpg" alt="Vols Porter Tremblant">
      </div>
      <div class="data">
        <h3 class="small-title">Fly from Toronto<br>to Mont-Tremblant</h3>
        <p class="regular-text">Arrive to destination in only 65 minutes!</p>
        <!-- <div class="promo">
          <img src="@/assets/img/fly-ski-free-2.svg" alt="Logo Fly abnd ski free">
          <div class="info">
            <h3 class="small-title">Fly & Ski Free!</h3>
            <p class="regular-text">Receive 2 free weekday lift tickets when you fly in Mont-Tremblant International Airport. In addition, get $25 in promotional gaming credit at the Casino de Mont-Tremblant when you book a flight from Toronto’s Billy Bishop Airport to Mont-Tremblant International Airport.</p>
          </div>
        </div> -->
        <br>
        <div class="cta-wrap">
          <img src="@/assets/img/porter-logo.svg" alt="Logo Porter">
          <a href="https://www.tremblant.ca/plan/getting-here/direct-flights-and-shuttle-service-to-tremblant?sc_lang=en&webSyncID=189422c7-13ce-7779-1397-6815d48ca5b8&sessionGUID=9e40a025-9836-e087-6bb4-921334211ee6&_ga=2.80179792.695294291.1666622112-736896602.1665598505&_gl=1*1o3drrs*_ga*NzM2ODk2NjAyLjE2NjU1OTg1MDU.*_ga_B1YVPN56M6*MTY2NjYyMjExMi4xNC4xLjE2NjY2MjMzMTUuNTkuMC4w" target="_blank" class="cta blanc-rouge">Book now</a>
        </div>
      </div>
    </section>

    <!--Vols-->
    <section class="vols-wrap" id="vols" v-if="$route.query && $route.query.market === 'usa' && marketPrice">
      <img src="@/assets/img/curve-prune.svg" class="curve" alt="Courbe" />
      <div class="img">
        <img src="@/assets/img/vols-3.jpg" alt="Vols Porter Tremblant">
      </div>
      <div class="data">
        <h3 class="small-title">Fly to Mont-Tremblant</h3>
        <p class="regular-text">Connecting flights from Boston, New York and Chicago</p>
        <!-- <div class="promo">
          <img src="@/assets/img/fly-ski-free-2.svg" alt="Logo Fly abnd ski free">
          <div class="info">
            <h3 class="small-title">Fly & Ski Free!</h3>
            <p class="regular-text">Receive 2 free weekday lift tickets when you fly in Mont-Tremblant International Airport. In addition, get $25 in promotional gaming credit at the Casino de Mont-Tremblant when you book a flight from Toronto’s Billy Bishop Airport to Mont-Tremblant International Airport.</p>
          </div>
        </div> -->
        <br>
        <div class="cta-wrap">
          <img src="@/assets/img/porter-logo.svg" alt="Logo Porter">
          <a href="https://www.tremblant.ca/plan/getting-here/direct-flights-and-shuttle-service-to-tremblant?sc_lang=en&webSyncID=189422c7-13ce-7779-1397-6815d48ca5b8&sessionGUID=9e40a025-9836-e087-6bb4-921334211ee6&_ga=2.80179792.695294291.1666622112-736896602.1665598505&_gl=1*1o3drrs*_ga*NzM2ODk2NjAyLjE2NjU1OTg1MDU.*_ga_B1YVPN56M6*MTY2NjYyMjExMi4xNC4xLjE2NjY2MjMzMTUuNTkuMC4w" target="_blank" class="cta blanc-rouge">Book now</a>
        </div>
      </div>
    </section>

    <section class="bloc_wrap solo hiver">
      <img src="@/assets/img/curve-vert-big.svg" class="curve" alt="Courbe" />
      <!-- <div class="bloc" data-inview="fadeInUp" data-delay="200">
        <div class="img">
          <img v-if="pageData && $route && $route.meta.lang === 'fr'" src="@/assets/img/politique-flexible-hiver-fr.jpg" alt="" />
          <img v-else-if="pageData && $route && $route.meta.lang === 'en'" src="@/assets/img/politique-flexible-hiver-en.jpg" alt="" />
        </div>
        <div class="data">
          <h3 class="small-title">{{ $t('site_ete_2022.politique_title') }}</h3>
          <a href="#" class="cta blanc-bleu politique-panel" @click.prevent="showpolitiquepanel">{{ $t('site_ete_2022.more') }}</a>
        </div>
      </div> -->
      <div class="bloc" data-inview="fadeInUp" data-delay="300">
        <div class="img">
          <img src="@/assets/img/ecoresponsabilite-hiver.jpg" alt="" />
        </div>
        <div class="data">
          <h3 class="small-title" v-html="$t('site_ete_2022.eco_small_title')"></h3>
          <a href="#" class="cta blanc-bleu eco-panel" @click.prevent="showecopanel">{{ $t('site_ete_2022.more') }}</a>
        </div>
      </div>
    </section>

    <news-letter color="hiver"></news-letter>

    <footer-bar></footer-bar>


    <!--Logo Partenaire-->
    <div class="logo-partenaire">
      <a v-if="$route.meta.lang === 'fr'" href="https://www.laurentides.com/fr" target="_blank"
        ><img src="@/assets/img/logo-tl-fr.png" alt="Logo Tourisme Laurentides"
      /></a>
      <a v-else-if="$route.meta.lang === 'en'" href="https://www.laurentides.com/en" target="_blank"
        ><img src="@/assets/img/logo-tl-en.png" alt="Logo Tourisme Laurentides"
      /></a>
    </div>

    <!--Note Yahoo finance source-->
    <div v-if="$route.query && $route.query.market === 'usa'" class="note-yahoo">
      <p class="regular-text">* Source - Yahoo Finance currency exchange for USD to CAD</p>
    </div>

    <!--Offer Popup right bottom-->
    <div class="deal-popup hiver" :class="{ active: dealpop, force: dealpopforce }">
      <div class="open_box" @click.prevent="toggledealpop">
        <img src="@/assets/img/arrow-left.svg" alt="Arrow" class="open"/>
        <p class="v_txt">{{ $t('site_ete_2022.show_offer') }}</p>
      </div>
      <img src="@/assets/img/arrow-right.svg" alt="Arrow" class="close" @click.prevent="toggledealpop" />
      <p class="small-title" v-html="$t('site_hiver_2023.al_lodging_pop')"></p>
      <a href="#" class="cta blanc-bleu" @click.prevent="showdealpanel">{{ $t('site_ete_2022.al_lodging_pop_cta') }}</a>
    </div>

    <!--Popup offre-->
    <div class="overlay-side-panel" :class="{ show: dealpanel }">
      <img src="@/assets/img/close.svg" alt="close" class="close" @click.prevent="hidedealpanel" />
      <div class="side-panel deal">
        <div class="img hiver_2023_in_season_dink" :class="{ ski: !toggle }"></div>
        <div class="toggle">
          <p :class="{ actif: toggle }" @click.prevent="table1">{{ $t('site.lodging') }}</p>
          <p :class="{ actif: !toggle }" @click.prevent="table2">Ski</p>
        </div>
        <div class="data hiver" :class="{ actif: toggle }">
          <div v-html="$t('site_hiver_2023.al_lodging_data')"></div>
          <a href="#" class="cta blanc-rouge" @click.prevent="showlodgingform2">{{ $t('site.reservez-long') }}</a
          ><br />
          <a v-if="$route.meta.lang === 'fr'" href="/hiver/2223/in-season/terms-hebergement/" class="regular-text modalite">{{ $t('site.modalites') }}</a>
          <a v-else-if="$route.meta.lang === 'en'" href="/en/hiver/2223/in-season/terms-hebergement/" class="regular-text modalite">{{
            $t('site.modalites')
          }}</a>
        </div>
        <div class="data hiver" :class="{ actif: !toggle }">
          <div v-html="$t('site_hiver_2023.al_entrepot_data')"></div>
          <a :href="$t('site_hiver_2023.al_entrepot_link')" target="_blank" class="cta blanc-rouge">{{ $t('site.achetez-short') }}</a>
          <br />
          <a v-if="$route.meta.lang === 'fr'" href="/hiver/2223/in-season/terms-entrepot/" class="regular-text modalite">{{ $t('site.modalites') }}</a>
          <a v-else-if="$route.meta.lang === 'en'" href="/en/hiver/2223/in-season/terms-entrepot/" class="regular-text modalite">{{ $t('site.modalites') }}</a>
        </div>
      </div>
      <div class="opacity" @click.prevent="hidedealpanel"></div>
    </div>

    <!--Popup formulaire-->
    <div class="overlay-form-loding" :class="{ show: formlodging }">
      <img src="@/assets/img/close.svg" alt="close" class="close" @click.prevent="hidelodgingform" />
      <div class="form-wrap">
        <h3 class="medium-title">{{ $t('site.reservez-long') }}</h3>

        <form
          :action="$t('site_hiver_2023.al_lodging_link')"
          class="lodging-form"
          target="_blank"
        >
          <div class="input">
            <p class="regular-text">{{ $t('site.arrivee') }}</p>
            <date-picker
              v-model="time1"
              name="arrivaldate"
              :lang="this.datepickerLang"
              :disabled-date="disabledBeforeToday"
              :input-attr="{ name: 'arrivaldate', required: 'required' }"
              format="MM/DD/YYYY"
              required
            ></date-picker>
          </div>
          <div class="input">
            <p class="regular-text">{{ $t('site.depart') }}</p>
            <date-picker
              v-model="time2"
              name="departuredate"
              :lang="this.datepickerLang"
              :disabled-date="disabledBeforeToday"
              :input-attr="{ name: 'departuredate', required: 'required' }"
              format="MM/DD/YYYY"
              required
            ></date-picker>
          </div>
          <div class="input">
            <p class="regular-text">{{ $t('site.adulte') }}</p>
            <input name="Adult" type="number" value="2" min="1" required />
          </div>
          <div class="input">
            <p class="regular-text">{{ $t('site.enfant') }}</p>
            <input name="Child" type="number" value="0" required />
          </div>
          <input type="submit" class="cta submit blanc-rouge" :value="$t('site.reservez-long')" />
        </form>
      </div>
      <div class="opacity" @click.prevent="hidelodgingform"></div>
    </div>

    <!--Popup Politique flexible-->
    <div class="overlay-side-panel" :class="{ show: politiquepanel }">
      <img src="@/assets/img/close.svg" alt="close" class="close" @click.prevent="hidepolitiquepanel" />
      <div class="side-panel">
        <div v-if="pageData && $route && $route.meta.lang === 'fr'" class="img politique_flexible_hiver_fr"></div>
        <div v-else-if="pageData && $route && $route.meta.lang === 'en'" class="img politique_flexible_hiver_en"></div>
        <div class="data">
          <h3 class="small-title">{{ $t('site_ete_2022.politique_title') }}</h3>
          <div v-html="$t('site_ete_2022.politique_data')"></div>
        </div>
      </div>
      <div class="opacity" @click.prevent="hidepolitiquepanel"></div>
    </div>

    <!--Panel Brindo-->
    <div class="overlay-side-panel" :class="{ show: brindopanel }">
      <img src="@/assets/img/close.svg" alt="close" class="close" @click.prevent="hidebrindopanel" />
      <div class="side-panel">
        <div class="img brindo"></div>
        <div class="data">
          <div v-html="$t('site_hiver_2023.brindo_data')"></div>
          <a v-if="$route.meta.lang === 'fr'" href="/hiver/2223/in-season/terms-brindo/" class="regular-text modalite">{{ $t('site.modalites') }}</a>
          <a v-else-if="$route.meta.lang === 'en'" href="/en/hiver/2223/in-season/terms-brindo/" class="regular-text modalite">{{ $t('site.modalites') }}</a>
        </div>
      </div>
      <div class="opacity" @click.prevent="hidebrindopanel"></div>
    </div>

    <!--Popup Écoresponsabilité-->
    <div class="overlay-side-panel" :class="{ show: ecopanel }">
      <img src="@/assets/img/close.svg" alt="close" class="close" @click.prevent="hideecopanel" />
      <div class="side-panel">
        <div class="img eco_hiver"></div>
        <div class="data">
          <h3 class="small-title" v-html="$t('site_ete_2022.eco_small_title')"></h3>
          <p class="regular-text">{{ $t('site_ete_2022.eco_intro_txt') }}</p>
          <p class="regular-text bold">{{ $t('site_ete_2022.eco_saviez_vous') }}</p>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_1')"></p>
          </div>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_2')"></p>
          </div>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_3')"></p>
          </div>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_4')"></p>
          </div>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_5')"></p>
          </div>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_6')"></p>
          </div>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_7')"></p>
          </div>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_8')"></p>
          </div>
          <div class="note">
            <p class="regular-text" v-html="$t('site_ete_2022.eco_point_9')"></p>
          </div>
        </div>
      </div>
      <div class="opacity" @click.prevent="hideecopanel"></div>
    </div>

    <!-- Dynamic Side Panel -->
    <div class="overlay-side-panel dynamic-side-panel" :class="{ show: dynamicPanelIsOpen }">
      <img src="@/assets/img/close.svg" alt="close" class="close" @click.prevent="toggleDynamicSidePanel(false)" />
      <div class="side-panel">
        <div
          v-if="dynamicPanelIsOpen && dynamicPanelItems && dynamicPanelItems.length"
          class="img"
          :style="'background-image:url(' + dynamicPanelItems[dynamicPanelPos].img + ')'"
        >
          <div v-if="dynamicPanelItems.length > 1" class="arrow-wrap prev" @click.prevent.stop="dynamicSidePanelGoTo('prev')">
            <img src="@/assets/img/prev.svg" alt="prev" />
          </div>
          <div v-if="dynamicPanelItems.length > 1" class="arrow-wrap next" @click.prevent.stop="dynamicSidePanelGoTo('next')">
            <img src="@/assets/img/next.svg" alt="next" />
          </div>
        </div>
        <div class="data">
          <span v-if="dynamicPanelIsOpen && dynamicPanelItems && dynamicPanelItems.length" v-html="dynamicPanelItems[dynamicPanelPos].data"></span>
        </div>
      </div>
      <div class="opacity" @click.prevent="toggleDynamicSidePanel(false)"></div>
    </div>
  </div>
</template>

<script>
import { isNil } from 'lodash'
import { mapState } from 'vuex'

import * as LottiePlayer from '@lottiefiles/lottie-player'

import GLightbox from 'glightbox'
import DatePicker from 'vue2-datepicker'

import 'vue2-datepicker/index.css'
import trans from '@/translations/index'

import NewsLetter from '@/components/NewsLetter'
import FooterBar from '@/components/FooterBar'

import getDocById from '@/firebase/init'

export default {
  components: { NewsLetter, FooterBar, DatePicker },

  head() {
    return {
      title: {
        inner: this.$t(`site_hiver_2023.al_lodging_meta_title`),
      },
      meta: [
        // Global Metas OG
        { name: 'application-name', content: this.$t(`site_hiver_2023.al_lodging_meta_title`) },
        {
          name: 'description',
          content: this.$t(`site_hiver_2023.al_lodging_meta_desc`),
          id: 'desc',
        },
        // Twitter OG
        { name: 'twitter:title', content: this.$t(`site_hiver_2023.al_lodging_meta_title`) },
        { name: 'twitter:card', content: 'Tremblant' },
        {
          n: 'twitter:description',
          c: this.$t(`site_hiver_2023.al_lodging_meta_desc`),
        },
        // Facebook / Open Graph
        { property: 'og:title', content: this.$t(`site_hiver_2023.al_lodging_meta_title`) },
        { property: 'og:site_name', content: 'Tremblant' },
        {
          property: 'og:description',
          content: this.$t(`site_hiver_2023.al_lodging_meta_desc`),
        },
        // Og Image
        {
          p: 'og:image',
          c: 'https://promo.tremblant.ca/vue-app-static-img/hiver-2023/bighit/dink.jpg',
        },
        {
          name: 'twitter:image',
          content: 'https://promo.tremblant.ca/vue-app-static-img/hiver-2023/bighit/dink.jpg',
        },
      ],
    }
  },

  props: {
    pageData: {
      type: Object,
      required: true,
      default: null,
    },
  },

  data() {
    return {
      formlodging: false,
      sidepanel: false,
      politiquepanel: false,
      brindopanel: false,
      ecopanel: false,
      dealpanel: false,
      lottieInstance: null,
      lightboxelement: null,
      datepickerLang: null,
      dealpop: false,
      dealpopforce: false,
      time1: new Date(),
      time2: null,
      calendarActiveFilter: 'Tous',
      dynamicPanelIsOpen: false,
      dynamicPanelPos: 0,
      dynamicPanelItems: [],
      marketPrice: null,
      toggle: true,
    }
  },

  watch: {
    $route: {
      async handler($route) {
        if (!isNil($route)) {
          const marketPrice = await getDocById()

          if (marketPrice) {
            this.marketPrice = marketPrice.currentPrice
          }

          if ($route.meta.lang === 'en') {
            this.calendarActiveFilter = 'All';
          }

          if ($route.hash) {
            setTimeout(() => {
              if ($route.hash === '#events') {
                const $target = document.querySelector('#events')
                $target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
              }
              if ($route.hash === '#quoi-faire') {
                const $target = document.querySelector('#quoi-faire')
                $target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
              }
              if ($route.hash === '#secteurs') {
                const $target = document.querySelector('#secteurs')
                $target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
              }
              if ($route.hash === '#vols') {
                const $target = document.querySelector('#vols')
                $target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
              }
              if ($route.hash === '#tab1') {
                this.dealpanel = true
              }
              if ($route.hash === '#tab2') {
                this.dealpanel = true
                this.toggle = false
              }
              if ($route.hash === '#avantages') {
                this.dynamicPanelIsOpen = true
                console.log('1');
                this.dynamicPanelPos = 0
                console.log('2');
                this.dynamicPanelItems = this.$t('dink_hiver_2023_activity')
                console.log('3');
              }
            }, 755)
          }
        }
      },
      immediate: true,
    },
  },

  computed: mapState('app', ['appTitle']),

  mounted() {
    this.lottieInstance = LottiePlayer

    this.lightboxelement = GLightbox
    GLightbox()

    const dt = new Date()
    dt.setDate(dt.getDate() + 1)
    this.time2 = dt

    this.datepickerLang = trans.fr.datepicker
    if (this.$route.meta.lang === 'en') {
      this.datepickerLang = trans.en.datepicker
    }
  },

  created() {
    window.addEventListener('scroll', () => {
      this.actiondealpop()
    })
  },

  methods: {
    table1() {
        this.toggle = true
    },
    table2() {
        this.toggle = false
    },
    togglecalendarFiler(value) {
      this.calendarActiveFilter = value
    },
    toggleDynamicSidePanel(value, items = [], pos = 0) {
      this.dynamicPanelIsOpen = value
      this.dynamicPanelItems = items
      this.dynamicPanelPos = pos
    },
    dynamicSidePanelGoTo(action) {
      if (action === 'prev') {
        if (this.dynamicPanelPos === 0) {
          this.dynamicPanelPos = this.dynamicPanelItems.length - 1
        } else {
          this.dynamicPanelPos -= 1
        }
      } else if (this.dynamicPanelPos === this.dynamicPanelItems.length - 1) {
        this.dynamicPanelPos = 0
      } else {
        this.dynamicPanelPos += 1
      }
    },
    showlodgingform() {
      if (this.formlodging) {
        this.formlodging = false
      } else {
        this.formlodging = true
      }
    },
    showlodgingform2() {
      if (this.formlodging) {
        this.formlodging = false
      } else {
        this.formlodging = true
        this.dealpanel = false
      }
    },
    hidelodgingform() {
      this.formlodging = false
    },
    toggledealpop() {
      if(this.dealpopforce === false) {
        this.dealpopforce = true
      } else {
        this.dealpopforce = false
      }
    },
    actiondealpop() {
      const st = document.documentElement.scrollTop
      const value = document.querySelector('#quoi-faire').offsetTop

      if (st >= value) {
        this.dealpop = true
      } else {
        if(this.dealpopforce) {
          this.dealpopforce = false
        }
        this.dealpop = false
      }
    },
    showecopanel() {
      if (this.ecopanel) {
        this.ecopanel = false
      } else {
        this.ecopanel = true
      }
    },
    hideecopanel() {
      this.ecopanel = false
    },
    showdealpanel() {
      if (this.dealpanel) {
        this.dealpanel = false
      } else {
        this.dealpanel = true
      }
    },
    hidedealpanel() {
      this.dealpanel = false
    },
    disabledBeforeToday(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date < today
    },
    showpolitiquepanel() {
      if (this.politiquepanel) {
        this.politiquepanel = false
      } else {
        this.politiquepanel = true
      }
    },
    hidepolitiquepanel() {
      this.politiquepanel = false
    },
    showbrindopanel() {
      if (this.brindopanel) {
        this.brindopanel = false
      } else {
        this.brindopanel = true
      }
    },
    hidebrindopanel() {
      this.brindopanel = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
</style>
